/* Tegelkanjer – interactie */
(function () {
  'use strict';
  var R = window.tkRoutes || { cart: '/cart', cartAdd: '/cart/add.js', cartJs: '/cart.js' };
  var ICON_CHECK = '<svg class="tk-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function money(cents) {
    cents = Math.round(cents);
    var e = Math.floor(cents / 100), r = cents % 100;
    return '€' + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (r < 10 ? '0' : '') + r;
  }
  function nl(n) {
    var s = (Math.round(n * 100) / 100).toFixed(2).replace(/\.?0+$/, '');
    return s.replace('.', ',');
  }

  /* ---------- mobiel menu ---------- */
  var drawer = document.getElementById('tkDrawer');
  function openDrawer(btn) {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var c = $('[data-tk-drawer-close]', drawer); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    $$('[data-tk-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  $$('[data-tk-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(b); }); });
  $$('[data-tk-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

  /* ---------- toast ---------- */
  var toast = document.getElementById('tkToast'), toastTimer;
  function showToast(html) {
    if (!toast) return;
    toast.innerHTML = html; toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(hideToast, 8000);
  }
  function hideToast() { if (toast) toast.hidden = true; }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); hideToast(); } });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tk-toast-close]')) { e.preventDefault(); hideToast(); }
  });

  function refreshCount() {
    return fetch(R.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-tk-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
        return c;
      });
  }

  /* ---------- aantal +/- (product + winkelwagen) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tk-step]');
    if (!b) return;
    var wrap = b.closest('.tk-qty'), inp = wrap && wrap.querySelector('input');
    if (!inp) return;
    var min = parseInt(inp.getAttribute('min') || '0', 10);
    var max = inp.getAttribute('max') ? parseInt(inp.getAttribute('max'), 10) : Infinity;
    var v = (parseInt(inp.value, 10) || 0) + parseInt(b.getAttribute('data-tk-step'), 10);
    inp.value = Math.min(max, Math.max(min, v));
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- in winkelwagen ---------- */
  $$('[data-tk-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = $('[data-tk-add]', form), label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Even geduld…'; }
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var one = form.getAttribute('data-unit-one') || 'stuk', many = form.getAttribute('data-unit-many') || 'stuks';
      fetch(R.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(function (item) {
          return refreshCount().then(function () {
            showToast('<div class="tk-toast__head">' + ICON_CHECK + 'Toegevoegd aan je winkelwagen</div>' +
              '<p style="margin:0">' + esc(item.product_title) + ' &middot; ' + qty + ' ' + (qty === 1 ? one : many) + '</p>' +
              '<div class="tk-toast__btns"><a class="tk-btn tk-btn--ghost" href="#" data-tk-toast-close>Verder winkelen</a>' +
              '<a class="tk-btn tk-btn--primary" href="' + R.cart + '">Naar winkelwagen</a></div>');
          });
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Er ging iets mis. Probeer het nog eens.';
          showToast('<div class="tk-toast__head">Dat lukte niet</div><p style="margin:0">' + esc(msg) + '</p>' +
            '<div class="tk-toast__btns"><a class="tk-btn tk-btn--dark" href="#" data-tk-toast-close>Sluiten</a><a class="tk-btn tk-btn--ghost" href="' + R.cart + '">Winkelwagen</a></div>');
        })
        .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
    });
  });

  /* ---------- productpagina: calculator, galerij, sticky ---------- */
  $$('[data-tk-product]').forEach(function (root) {
    var json = $('[data-tk-product-json]', root);
    var d = json ? JSON.parse(json.textContent) : {};
    var qty = $('[data-tk-qty]', root), m2In = $('[data-tk-m2]', root), waste = $('[data-tk-waste]', root);
    var result = $('[data-tk-calc-result]', root), summary = $('[data-tk-summary]', root), split = $('[data-tk-split]', root);
    var stickyPrice = $('[data-tk-sticky-total]');

    function render() {
      if (!qty) return;
      var q = Math.max(1, parseInt(qty.value, 10) || 1);
      if (summary && !d.partij) {
        if (d.m2 > 0) {
          summary.innerHTML = '<strong>' + q + ' ' + (q === 1 ? 'doos' : 'dozen') + '</strong> = ' + nl(q * d.m2) + ' m² &middot; totaal <strong>' + money(q * d.price) + '</strong>';
        } else {
          summary.innerHTML = 'Totaal <strong>' + money(q * d.price) + '</strong>';
        }
      }
      if (stickyPrice) stickyPrice.textContent = money(q * d.price);
      if (split) {
        if (d.tracked && d.stock > 0 && q > d.stock && d.policy === 'continue') {
          split.hidden = false;
          split.innerHTML = '<strong>' + d.stock + ' ' + (d.stock === 1 ? 'doos' : 'dozen') + '</strong> zijn direct leverbaar. De overige <strong>' + (q - d.stock) + '</strong> bestellen we voor je bij onze leverancier (levertijd ' + esc(d.leadtime) + '). We leveren alles in één keer.';
        } else { split.hidden = true; }
      }
    }
    function calc() {
      if (!m2In || !(d.m2 > 0)) return;
      var v = parseFloat(String(m2In.value).replace(',', '.'));
      if (!v || v <= 0) { result.innerHTML = result.getAttribute('data-default'); return; }
      var pct = waste && waste.checked ? d.waste : 0;
      var boxes = Math.max(1, Math.ceil(v * (1 + pct / 100) / d.m2 - 1e-9));
      qty.value = boxes; render();
      result.innerHTML = 'Voor ' + nl(v) + ' m²' + (pct ? ' + ' + pct + '% snijverlies' : '') + ' heb je <strong>' + boxes + ' ' + (boxes === 1 ? 'doos' : 'dozen') + '</strong> nodig (' + nl(boxes * d.m2) + ' m²). Totaal <strong>' + money(boxes * d.price) + '</strong>.';
    }
    if (m2In) m2In.addEventListener('input', calc);
    if (waste) waste.addEventListener('change', calc);
    if (qty) qty.addEventListener('input', render);
    render();

    var main = $('[data-tk-gallery-main]', root);
    $$('[data-tk-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.srcset = t.getAttribute('data-srcset') || '';
        main.src = t.getAttribute('data-src');
        main.alt = t.getAttribute('data-alt') || '';
        $$('[data-tk-thumb]', root).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    var sticky = $('[data-tk-sticky]'), buy = $('[data-tk-add-form]', root);
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var en = es[0];
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(buy);
      var sb = $('[data-tk-sticky-btn]', sticky);
      if (sb) sb.addEventListener('click', function () { var b = $('[data-tk-add]', buy); if (b) b.click(); });
    }
  });

  /* ---------- collectie: filters & sortering ---------- */
  $$('[data-tk-filters]').forEach(function (form) {
    form.addEventListener('change', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
  });
  $$('[data-tk-filter-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = document.getElementById(b.getAttribute('aria-controls'));
      if (!f) return;
      var open = f.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  $$('[data-tk-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  /* ---------- winkelwagen ---------- */
  var cartForm = $('[data-tk-cart-form]');
  if (cartForm) {
    var t;
    $$('[data-tk-line-qty]', cartForm).forEach(function (inp) {
      inp.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () { var u = cartForm.querySelector('[name="update"]'); if (u) u.click(); }, 450);
      });
    });
    var radios = $$('[name="attributes[Levering]"]', cartForm), dateLabel = $('[data-tk-date-label]', cartForm);
    function syncLabel() {
      var c = radios.filter(function (r) { return r.checked; })[0];
      if (dateLabel && c) dateLabel.textContent = c.value.indexOf('Afhalen') === 0 || c.value.indexOf('Zelf') === 0 ? 'Voorkeursdatum afhalen' : 'Voorkeursdatum bezorging';
    }
    radios.forEach(function (r) { r.addEventListener('change', syncLabel); });
    syncLabel();
  }
})();